import type { Feature } from './Feature';
import { getLocalOverride } from './getLocalOverride';

/**
 * Base utility for checking if a feature can be used by a specific site.
 *
 * N.B. do not export from this module.
 *
 * @private
 */
export function isAllowedBase(feature: Feature, availableFeatures: Feature[]): boolean {
  const localStorageOverride = getLocalOverride(feature);

  if (localStorageOverride !== null) {
    return localStorageOverride;
  }

  return availableFeatures.includes(feature);
}
